import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { KryptomonsService } from '../../../../services/kryptomons/kryptomons.service'
import { UserService } from '../../../../services/user/user.service'
import { environment } from 'environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http'
import { getCookie } from 'app/common/utils/cookie.util';
import { LootboxesContractService } from 'app/services/contract/contracts-services/lootboxes.service';
import { first, switchMap, takeWhile, tap, timer, of } from 'rxjs';
import { ContractsService } from 'app/services/contract/contracts.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { eContracts } from 'app/services/contract/contract.config';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { BigNumber } from "ethers";
import { Web3Service } from 'app/services/web3/web3.service';
import { eStatus } from 'app/services/web3/web3.config';
import { SpinnerService } from 'app/services/spinner/spinner.service';
import { CoinService } from 'app/services/coin/coin.service';
import { PancakeV2Service } from 'app/services/contract/contracts-services/pancake.service';
import { UserItemsService } from 'app/services/user-items/user-items.service';
import { analyticsTrack } from 'app/services/auth/analytics.service';



@Component({
  selector: 'kryptomon-migrate',
  templateUrl: './kryptomon-migrate.component.html',
  styleUrls: ['./kryptomon-migrate.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KryptomonMigrateComponent implements OnChanges {

  @ViewChild('chart') chart: any;

  // @Input() visible: boolean = false;
  // @Output() onMigrationCompleted: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() closeDialog: EventEmitter<null> = new EventEmitter<null>()
  showSelector: boolean = false;
  selectedMon
  allMons = []
  wallet: string
  curentId: string
  startingMon
  basicData: any;
  basicOptions: any;
  migrationType = [true, false]
  monSelectedIndex: number
  finalDataSet = [0, 0, 0, 0, 0]
  finalDataSetClean = [0, 0, 0, 0, 0]
  migrateFree: boolean
  migrateNft: boolean
  migrateTimestamp: number
  migrateSuccess = false;
  kmonBalance
  migrationPrices = [{ usd: 5, kmon: 0 }, { usd: 30, kmon: 0 }]
  kmonPrice
  usdPrice
  isPackageModalOpened = false;



  constructor(
    private kryptomonService: KryptomonsService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private http: HttpClient,
    private lootboxesContractService: LootboxesContractService,
    private tokenService: TokenService,
    private contractsService: ContractsService,
    private toastService: ToastService,
    private web3Service: Web3Service,
    private spinnerService: SpinnerService,
    private router: Router,
    private coinService: CoinService,
    private pancakeV2Service: PancakeV2Service,
    private userItemsService: UserItemsService) {

    this.wallet = this.userService._userInfoData.recordedWallet;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      console.log(changes)

    }
  }

  ngOnInit() {
    console.log('init migrate')

    //this.userItemsService.getLootboxItems(this.wallet).subscribe();

    this.pancakeV2Service.isConversionCompleted$.pipe(first()).subscribe(
      isCompleted => {
        if (isCompleted) {
          this.migrateRouter()
        }//to refresh Kmon balance
      }
    )

    this.tokenService.KMONbalance(this.wallet).pipe(first()).subscribe();
    this.tokenService.KMONBalance$.subscribe(value => {
      this.kmonBalance = value.rounded;
    });

    this.coinService.getKmonPrice().subscribe((item: any) => {
      console.log(item)
      for (let i = 0; i < this.migrationPrices.length; i++) {
        this.migrationPrices[i].kmon = (Math.round(this.migrationPrices[i].usd / item.kryptomon.usd * 100)) / 100
      }
      console.log(this.migrationPrices)
      this.updateMigrationPrices()
    })

    this.activatedRoute.params.subscribe(async (params: Params) => {
      this.curentId = params['id']
      console.log(this.curentId)

    })

    this.kryptomonService.getAll(this.wallet).subscribe();
    this.kryptomonService.kryptomons$.subscribe((mons) => {
      this.startingMon = mons.filter(x => x.tokenId == this.curentId)[0];


      console.log(this.startingMon)

      //    let mon:any = {}
      //   if(!this.startingMon.name){
      //     mon.id = this.startingMon.tokenId;
      //   }else{
      //     mon.id = this.startingMon.name;
      //   }

      //   if(this.startingMon.status==1){
      //     mon.pic = environment.apiImages + "images/kryptomons/png/kmon_" + this.startingMon.tokenId + "_png.png"
      //   }else{
      //     mon.pic = environment.apiImages + "images/kryptomons-junior/png/kmon_" + this.startingMon.tokenId + "_png.png"
      //   }

      //   mon.speciality = this.startingMon.speciality;
      //   mon.elementType = this.startingMon.elementType;
      //   mon.elementTypeSecond = this.startingMon.elementTypeSecond;
      //   mon.isBreedingVisible = false;
      //   mon.sex = this.startingMon.genes.sex;
      //   mon.generation = this.startingMon.genes.generation;
      //   mon.ranking = this.startingMon.ranking;
      //   mon.isFrozen = this.startingMon.gameMetadata.isFreezed;

      //   this.startingMon.cardData = mon;

      if (this.startingMon.isStarter) {
        this.selectMigrationType(0)
      } else {
        this.selectMigrationType(1)
      }


      this.allMons = mons.filter(x => !x.isStarter && x.tokenId !== this.startingMon.tokenId && x.status > 0);

      // for (let i = 0; i < this.allMons.length; i++) {
      //   let mon: any = {}
      //   if (!this.allMons[i].name) {
      //     mon.id = this.allMons[i].tokenId;
      //   } else {
      //     mon.id = this.allMons[i].name;
      //   }

      //   if (this.allMons[i].status == 1) {
      //     mon.pic = environment.apiImages + "images/kryptomons/png/kmon_" + this.allMons[i].tokenId + "_png.png"
      //   } else {
      //     mon.pic = environment.apiImages + "images/kryptomons-junior/png/kmon_" + this.allMons[i].tokenId + "_png.png"
      //   }

      //   mon.speciality = this.allMons[i].speciality;
      //   mon.elementType = this.allMons[i].elementType;
      //   mon.elementTypeSecond = this.allMons[i].elementTypeSecond;
      //   mon.isBreedingVisible = false;
      //   mon.sex = this.allMons[i].genes.sex;
      //   mon.generation = this.allMons[i].genes.generation;
      //   mon.ranking = this.allMons[i].ranking;
      //   mon.isFrozen = this.allMons[i].gameMetadata.isFreezed;

      //   this.allMons[i].cardData = mon;
      //   console.log(this.allMons)
      // }
    })

    this.web3Service.signStatus$.pipe(
      switchMap(signRes => {
        let migrate_status = signRes.get('migrate');
        console.log(migrate_status)
        if (migrate_status?.status === eStatus.success) {
          let post = {
            signature: migrate_status.value.result,
            wallet: this.wallet,
            timestamp: this.migrateTimestamp,
            oldKryptomonId: parseInt(this.startingMon.tokenId),
            newKryptomonId: parseInt(this.selectedMon.tokenId),
            entityToken: getCookie('playfab-entity-token'),
            free: this.migrateFree,
            isNft: this.migrateNft
          }
          console.log(post);
          return this.http.post(environment.apiBaseUrlV22 + 'kryptomon-starters/migrate', post)
        } else {
          return of('notinit');
          this.spinnerService.setSpinner(false);
        };
      })).subscribe(item => {
        console.log(item)
        if (item !== 'notinit') {
          this.spinnerService.setSpinner(false);
          //this.whitelist(item)
          this.migrateSuccess = true;
          if (this.migrateFree) {
            var analyticsType = "Overwrite"
            var analyticsKind = "Syntethic > NFT"
          } else {
            var analyticsKind = "NFT > NFT"
            if (this.migrationType[0]) {
              var analyticsType = "Overwrite"
            } else {
              var analyticsType = "Mergw"
            }
          }
          analyticsTrack("Migrate Training Levels", {
            type: analyticsType,
            combination: analyticsKind
          })
          if (this.migrateNft) {
            // this.onMigrationCompleted.emit(true);
            this.kryptomonService.getDetail(this.curentId).subscribe();
          } else {
            setTimeout(() => {
              this.openMigrated()
            }, 1500)
          }

        }
      }, (err) => {
        console.log(err)
        this.spinnerService.setSpinner(false);
      });
  }

  updateMigrationPrices() {
    console.log(this.migrationType)
    if (this.migrationType[1] && this.startingMon.isStarter) {

      this.kmonPrice = this.migrationPrices[0].kmon
      this.usdPrice = this.migrationPrices[0].usd
    } else if (!this.startingMon?.isStarter && this.migrationType[1]) {
      this.kmonPrice = this.migrationPrices[1].kmon
      this.usdPrice = this.migrationPrices[1].usd
    }
  }

  selectMigrationType(index) {
    for (let i = 0; i < this.migrationType.length; i++) {
      if (i == index) {
        this.migrationType[i] = true;
      } else {
        this.migrationType[i] = false;
      }
    }
    this.updateMigrationPrices()
    if (this.selectedMon) {
      this.selectMon(this.monSelectedIndex)
    }
  }


  onHide() {

  }

  selectorToggle() {
    this.showSelector = !this.showSelector
    if (this.selectedMon) {
      this.selectedMon = undefined
      this.monSelectedIndex = undefined
    }
  }


  populateChart(startingDataset, finalDataSet) {
    setTimeout(() => {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      this.basicData = {
        labels: ['Main Element', 'Secondary Element', 'Stamina', 'Attack', 'Resistance'],
        datasets: [
          {
            type: 'bar',
            label: 'Dataset 1',
            backgroundColor: (context) => {
              if (!context.element.x || !context.element.width) {
                return
              }

              const {
                ctx
              } = context.chart;

              const {
                x,
                width
              } = context.element;

              const background_1 = ctx.createLinearGradient(x - (width / 2), 0, x + (width / 2), 0);

              background_1.addColorStop(0, '#7a632c');
              background_1.addColorStop(1, '#7e4f30');

              return background_1;
            },
            borderRadius: 5,
            maxBarThickness: 25,
            data: startingDataset
          },
          {
            type: 'bar',
            label: 'Dataset 2',
            backgroundColor: (context) => {
              if (!context.element.x || !context.element.width) {
                return
              }

              const {
                ctx
              } = context.chart;

              const {
                x,
                width
              } = context.element;

              const background_1 = ctx.createLinearGradient(x - (width / 2), 0, x + (width / 2), 0);

              background_1.addColorStop(0, 'rgba(243,186,47,1)');
              background_1.addColorStop(1, 'rgba(255,137,57,1)');

              return background_1;
            },
            borderRadius: 5,
            maxBarThickness: 25,
            data: finalDataSet
          }
        ]
      };

      this.basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
          tooltip: {
            enabled: false
          },
          legend: {
            display: false,
            labels: {
              color: textColor
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              color: textColorSecondary,
            },
            display: false
          },
          y: {
            stacked: true,
            ticks: {
              color: textColorSecondary
            },
            max: 50,
            min: 0

          }
        }
      };
      console.log(this.basicData)
      console.log(this.basicOptions)
      this.chart.refresh();
    }, 100);
  }

  selectMon(index) {
    this.monSelectedIndex = index;
    this.selectedMon = this.allMons[index];
    if (Object.keys(this.selectedMon.gameMetadata).length == 0) {
      this.selectedMon.gameMetadata.mainFamilyTalentLevel = 0;
      this.selectedMon.gameMetadata.secondaryFamilyTalentLevel = 0;
      this.selectedMon.gameMetadata.hpLevel = 0;
      this.selectedMon.gameMetadata.attackLevel = 0;
      this.selectedMon.gameMetadata.defenseLevel = 0;
    }
    console.log(this.selectedMon)
    this.showSelector = false;
    this.changeDetector.detectChanges()

    let startingDataset = [
      this.selectedMon.gameMetadata.mainFamilyTalentLevel,
      this.selectedMon.gameMetadata.secondaryFamilyTalentLevel,
      this.selectedMon.gameMetadata.hpLevel,
      this.selectedMon.gameMetadata.attackLevel,
      this.selectedMon.gameMetadata.defenseLevel
    ]


    if (this.migrationType[0]) {
      var simulateType = "False"
    } else {
      var simulateType = "True"
    }
    let post = {
      oldKryptomonId: parseInt(this.startingMon.tokenId),
      newKryptomonId: parseInt(this.selectedMon.tokenId),
      entityToken: getCookie('playfab-entity-token'),
      merge: simulateType
    }
    console.log(post);
    this.http.post(environment.apiBaseUrlV22 + 'kryptomon-starters/migrate/simulate', post).subscribe((item: any) => {
      let dataResponse = item.data.FunctionResult.data.upgradableElements;
      if (dataResponse) {
        this.finalDataSet = [
          dataResponse[0].level - this.selectedMon.gameMetadata.mainFamilyTalentLevel,
          dataResponse[1].level - this.selectedMon.gameMetadata.secondaryFamilyTalentLevel,
          dataResponse[4].level - this.selectedMon.gameMetadata.hpLevel,
          dataResponse[3].level - this.selectedMon.gameMetadata.attackLevel,
          dataResponse[2].level - this.selectedMon.gameMetadata.defenseLevel
        ]
        this.finalDataSetClean = [
          dataResponse[0].level,
          dataResponse[1].level,
          dataResponse[4].level,
          dataResponse[3].level,
          dataResponse[2].level
        ]
        console.log(this.finalDataSet)
        this.populateChart(startingDataset, this.finalDataSet)
      }
    })

  }

  balanceChecker() {
    console.log(this.kmonBalance)
    console.log(this.kmonPrice)

    if (this.kmonBalance >= this.kmonPrice || this.migrationType[0]) {
      this.migrateRouter();
    } else {
      if (this.migrationType[1]) {
        if (this.startingMon.isStarter) {
          var item_purchased = "MIGRATE_SYNTHETIC_TO_NFT"
        } else {
          var item_purchased = "MIGRATE_NFT_TO_NFT"
        }
      }
      this.userItemsService.getLootboxItems(this.wallet).subscribe((items:any)=>{
      let item = items.filter(i => i.type == item_purchased);
      console.log(items)
      console.log(item)
      if (item[0]?.count > 0) {
        this.migrateRouter();
      }else{
        this.isPackageModalOpened = true;
      }
    })
      
    }
  }

  migrateRouter() {
    this.spinnerService.setSpinner(true);
    if (this.startingMon.isStarter) {
      if (this.migrationType[0]) {
        this.executeMigration('free', 'starter');
      } else {
        this.allowanceCheck('starter')
      }
    } else {
      this.allowanceCheck('nft')
    }
  }


  allowanceCheck(kind) {
    if (kind == 'starter') {
      var item_purchased = "MIGRATE_SYNTHETIC_TO_NFT"
    } else {
      var item_purchased = "MIGRATE_NFT_TO_NFT"
    }
    let that = this;
    let lootboxesContractAddress: string = this.contractsService.getContractAddress(eContracts.Lootbox);
    this.userService.userInfo$.subscribe(user => {
      this.tokenService.allowance(user.recordedWallet, lootboxesContractAddress).subscribe(allowance => {
        // console.log('allowance', allowance);
        let hasAllowanceItems = BigNumber.from(allowance).gt(0);
        // console.log('hasAllowanceItems', hasAllowanceItems);
        //this.spinnerService.setSpinner(true);
        if (hasAllowanceItems) {
          // console.log('start Purchase');
          that.userItemsService.getLootboxItems(this.wallet).subscribe((items:any)=>{
            let item = items.filter(i => i.type == item_purchased);
            console.log(items)
            console.log(item)
            if (item[0]?.count > 0) {
              that.executeMigration('paid', kind);
            } else {
              that.purchaseMigrateTicket(kind);
            }
          })

        } else {
          this.tokenService.approve(user.recordedWallet, lootboxesContractAddress).pipe(first()).subscribe({
            next(value) {
              console.log('value approve', value)
              that.userItemsService.getLootboxItems(this.wallet).subscribe((items:any)=>{
                let item = items.filter(i => i.type == item_purchased);
                console.log(items)
                console.log(item)
                if (item[0].count > 0) {
                  that.executeMigration('paid', kind);
                } else {
                  that.purchaseMigrateTicket(kind);
                }
              })
            },
            error(err) {
              // console.log('err', err);
              //-32603 is a Magic code 
              that.spinnerService.setSpinner(false);
              if (err.code === -32603) that.toastService.add({
                severity: 'error',
                summary: 'errorMsg.insufficientFunds',
                detail: 'toastMessage.refillWallet',
              });
              else if (err.code === 4001) {
                //that.spinnerService.setSpinner(false);
              }//Metamask code, user denied transaction
              else {
                that.toastService.genericError();
                //that.spinnerService.setSpinner(false);
              }
              //that.spinnerService.setSpinner(false);
            }
          }
          );
        }
      }
      )
    })
  }

  purchaseMigrateTicket(kind) {
    if (kind == 'starter') {
      var itemId = "0x4d4947524154455f53594e5448455449435f544f5f4e46540000000000000000"
    } else {
      var itemId = "0x4d4947524154455f4e46545f544f5f4e46540000000000000000000000000000"
    }
    let that = this
    this.lootboxesContractService.buyItem(this.wallet, itemId, 1).pipe(first()).subscribe({
        next(item:any) {
          console.log(item)
          //that.spinnerService.setSpinner(false);
          if (item.status) {
            console.log('purchase successful');
            // that.userItemsService.getLootboxItems(wallet).pipe(first()).subscribe();//to refresh item count
            //that.refreshItemCount(wallet);
            //that.tokenService.KMONbalance(wallet).pipe(first()).subscribe();//to refresh Kmon balance
            // that.spinnerService.setSpinner(false);
            that.executeMigration('paid', kind);
          } else {
            console.log('error purchase');
            that.spinnerService.setSpinner(false);
            //that.spinnerService.setSpinner(false);
          }
        }, error(err) {
        that.spinnerService.setSpinner(false);
        if (err.code !== 4001) {
          //that.spinnerService.setSpinner(false);
          that.toastService.genericError();
        } //that.toastService.genericError();
        //that.spinnerService.setSpinner(false);
      }
    })

  }

  executeMigration(type, kind) {
    console.log(type);
    console.log(kind)
    if (type == 'paid') {
      this.migrateFree = false;
      var item_purchased = "MIGRATE_SYNTHETIC_TO_NFT"
    } else {
      this.migrateFree = true;
    }

    console.log(this.migrateFree)

    if (kind == 'nft') {
      this.migrateNft = true;
      var item_purchased = "MIGRATE_NFT_TO_NFT"
    } else {
      this.migrateNft = false;
    }

    if (this.migrateFree) {
      this.migrateTimestamp = Date.now();
      this.web3Service.signMessage(this.wallet, "migrate", "Migrate my starter " + this.startingMon.tokenId + " kryptomon data to " + this.selectedMon.tokenId + " kryptomon: " + this.migrateTimestamp);
    } else {
      this.refreshItemCount(this.wallet, item_purchased)
    }




  }

  openMigrated() {
    // this.visible = false;
    this.closeDialog.emit(null);
    this.router.navigate(["/kryptomons/", this.selectedMon.tokenId])

  }

  refreshItemCount(wallet: string, item_purchased) {
    const maxAttempts = 20;
    const interval = 5000; // 6 seconds
    let attempts = 0;
    //this.spinnerService.setSpinner(true);
    timer(0, interval)
      .pipe(
        takeWhile(() => attempts < maxAttempts),
        switchMap(() => this.userItemsService.getLootboxItems(wallet))
      ).subscribe((items: any) => {
        let item = items.filter(i => i.type == item_purchased);
        console.log(items)
        console.log(item)
        console.log(item_purchased)
        if (item[0]?.count > 0) {
          attempts = maxAttempts
          //esegue migrazione su db
          this.migrateTimestamp = Date.now();
          this.web3Service.signMessage(this.wallet, "migrate", "Migrate my starter " + this.startingMon.tokenId + " kryptomon data to " + this.selectedMon.tokenId + " kryptomon: " + this.migrateTimestamp);
        } else {
          attempts++
          if (attempts == maxAttempts) {
            this.toastService.genericError();
            this.spinnerService.setSpinner(false);
          }
        };

        console.log('number attepmpts:', attempts)
        /*if (attempts === maxAttempts) {
          this.spinnerService.setSpinner(false);
          //this.toastService.genericError();
        }*/
      })
  }
}
